// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Reorder = function Reorder(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M2.8 9.7l4.9 4.9a.4.4 0 00.6 0l4.9-4.9a.4.4 0 00-.3-.7H3.1a.4.4 0 00-.3.7zM13.2 6.2L8.3 1.3a.4.4 0 00-.6 0L2.8 6.2a.4.4 0 00.3.7H13a.4.4 0 00.2-.7z"
    }))
  );
};

export default Reorder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Reorder.js
// module id = 1043
// module chunks = 0